export const guard = {
    exercice:{
        validated:{
            unauthorized: `<div >L'accès à cet écran n'est pas autorisé une fois l'exercice validé.</div><div class="mt-1">Vous avez été redirigé vers le tableau de bord de votre exercice.</div>`
        }
    }
}
